<!-- eslint-disable max-len -->
<template>
  <aha-modal-group
    @hide="hide()"
  >
    <template #header>
      <div>
        <aha-icon-container
          class="font-bold truncate cursor-pointer"
          size="md"
          icon-class="bg-primary-90 text-base-0"
        >
          <aha-icon
            name="share-collab"
            width="14"
            height="14"
            viewBox="0 0 18 16"
          />
        </aha-icon-container>
        <span>
          {{ $i18nPresenter.t("Invite to edit") }}
        </span>
      </div>
    </template>
    <template #main>
      <ShareToTeamForEditMain :team-name="teamName" :presentation="presentation"></ShareToTeamForEditMain>
    </template>
  </aha-modal-group>
</template>
<script>
import ShareToTeamForEditMain from '@/components-v2/editor-share-v2/ShareToTeamForEditMain'

export default {
  components: { ShareToTeamForEditMain },
  props: {
    presentation: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    teamName: {
      type: String,
      default: 'your current team',
    },
  },
  methods: {
    hide() {
      this.$emit('hide')
    },
  },
}
</script>
<style scoped lang='scss'>
</style>
